import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthRoles } from '../constants/auth-roles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getRoles = (payload: any): string[] => {
  const role: unknown = payload?.role;
  if (Array.isArray(role)) {
    return role;
  }
  if (typeof role === 'string') {
    return [role];
  }
  return [];
};

export const superAdminGuard$: CanActivateFn = () => {
  const oidc = inject(OidcSecurityService);
  const router = inject(Router);
  const unauthorized = router.createUrlTree(['/unauthorized']);

  const { userData } = oidc.userData();
  if (!userData) {
    return unauthorized;
  }

  const roles = getRoles(userData);
  return roles.includes(AuthRoles.SuperAdmin) ? true : unauthorized;
};
